import { useFormik } from 'formik';
import { ChannelsWebSurvey } from '../../../../../shared/types/modules/channels-web-information';
import { getQuestions, initialValues } from './formData';
import { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Question } from './props';

export const useChannelsSurvey = ({
    onChangeFormik,
}: {
    onChangeFormik?: (formik: any) => void;
}) => {
    const [questions, setQuestions] = useState<Question[]>([]);

    const validationSchema = Yup.object({
        question1: Yup.array()
            .of(Yup.string())
            .min(1, 'Debe seleccionar al menos una opción')
            .max(4, 'Solo puedes seleccionar hasta 4 opciones'),
    });

    const formik = useFormik<ChannelsWebSurvey>({
        initialValues: {
            ...initialValues,
            question1: Array.isArray(initialValues.question1)
                ? initialValues.question1
                : [],
        },
        validationSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            console.log('Formulario de encuesta enviado:', values);
        },
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        const data = getQuestions();
        setQuestions(data.questions);
        formik.setFieldValue('type', data.type);
    }, []);

    return {
        formik,
        questions,
    };
};
